"use client";
import SearchIcon from "@/assets/svg/SearchIcon";
import { Table } from "@/components/atoms/Table";
import { TextField } from "@/components/atoms/TextField";
import { useDebounce } from "@/lib/hooks/useDebounce";
import { useQueryState } from "@/lib/hooks/useQueryState";
import { CorrectionsStoryblok } from "@/types/blok-types";
import clsx from "clsx";
import { CorrectionDownload } from "./Download";
import { type CorrectionsData } from "./actions";
import { useCorrectionSearch } from "./hooks";
import styles from "./index.module.css";
import { Suspense } from "react";

interface Props {
  data: CorrectionsData;
  blok: CorrectionsStoryblok;
}

export const UnsuspendedCorrectionList = ({ data, blok }: Props) => {
  const [query, setQuery] = useQueryState<string>("q", "", {
    replace: true,
  });

  return (
    <div data-layout="container">
      <fieldset className={styles.filters}>
        <TextField
          id="corrections-search-field"
          defaultValue={query}
          onChange={(e) => setQuery(e.target.value)}
          label={blok.searchLabel}
          icon={<SearchIcon />}
        />
      </fieldset>
      <CorrectionsTable data={data} searchTerm={query} />
    </div>
  );
};

export const CorrectionList: typeof UnsuspendedCorrectionList = (props) => {
  return (
    <Suspense>
      <UnsuspendedCorrectionList {...props} />
    </Suspense>
  );
};

const CorrectionsTable = ({
  data: initialData,
  searchTerm,
}: {
  data: CorrectionsData;
  searchTerm: string;
}) => {
  const query = useDebounce(searchTerm);

  const { data, isFetching } = useCorrectionSearch({
    search: query,
    initialData,
  });

  return (
    <Table>
      <thead>
        <tr>
          <td>Produkt</td>
          <td></td>
        </tr>
      </thead>
      <tbody className={clsx(isFetching && styles.isLoading)}>
        {data?.map((correction) => (
          <tr data-correction={correction.key} key={correction.id}>
            <td>
              {correction.craft_sku} {correction.craft_name}
            </td>
            <td>
              <CorrectionDownload filename={correction.filename} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
